import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { cloneDeep, isEqual } from 'lodash';
import * as definitionActions from '../../actions/definitionActions';
import GenericButton from '../common/GenericButton';
// import DefinitionTree from '../common/DynamicTree/DefinitionTree';
import DefinitionTarget from '../common/DynamicTree/DefinitionTarget';
import CreateEditDefinition from '../common/CreateEditDefinition';
import AddToDefinition from '../common/AddToDefinition';
import BrowseShared from '../common/BrowseShared';
import GenericSendToPopover from '../common/GenericSendToPopover';
import ImportGeographyAndRespondent from '../common/ImportGeographyAndRespondent';
import Modal from '../common/Modal/Modal';
import { FLEX_STUDY_TAG } from '../../constants';

import DefinitionTreeV2 from './DefinitionTreeV2';


const smallModalStyle = {
  width: '30%',
  height: 'auto',
  left: '30%',
  top: '30%',
};

const mediumModalStyle = {
  width: '60%',
  height: 'auto',
  left: '23%',
  top: '10%',
};

class DefinitionsV2 extends Component {
  constructor(props) {
    super(props);
    let definitionList = [];
    if (this.props.loginResponse &&
      this.props.activeAccountId && this.props.moduleStudy) {
      if (this.props.definitionList && this.props.definitionList.data
        && this.props.definitionList.data.length > 0) {
        definitionList = cloneDeep(this.props.definitionList.data)
      } else {
        this.reloadDefinition(this.props.moduleStudy);
      }
    }
    this.state = { targetData: [], definitionList, selectedDefinition: {} };
  }

  componentDidMount() {
    if (this.props.moduleStudy && this.props.moduleStudy.pn) {
      this.reloadDefinition(this.props.moduleStudy);
      this.props.definitionActions.clearDefinitionTarget();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      nextProps.moduleStudy &&
      (!isEqual(this.props.moduleStudy, nextProps.moduleStudy))
    ) {
      this.reloadDefinition(nextProps.moduleStudy);
      this.props.definitionActions.clearDefinitionTarget();
      this.setState(() => ({
        selectedDefinition: {},
      }))
      // this.props.definitionActions.getDefinitionTreeLoad(
      //   this.props.loginResponse.data.token,
      //   this.props.loginResponse.data.uid,
      //   this.props.activeAccountId,
      //   nextProps.moduleStudy.pn,
      // );
    } else {
      if (
        this.props.definitionList !== nextProps.definitionList &&
        nextProps.definitionList &&
        nextProps.definitionList.status === 'SUCCESS'
      ) {
        this.setState({ definitionList: [...nextProps.definitionList.data] });
        if (
          this.state.selectedDefinition &&
          this.state.selectedDefinition.definitionId
        ) {
          this.props.definitionActions.getDefinitionTargetLoad(
            this.props.activeAccountId,
            this.state.selectedDefinition.definitionId,
          );
        }
      }

      if (!nextProps.definitionTarget) {
        this.setState({ targetData: [] });
      } else if (
        this.props.definitionTarget !== nextProps.definitionTarget &&
        nextProps.definitionTarget.status === 'SUCCESS'
      ) {
        this.setState({ targetData: [...nextProps.definitionTarget.data] });
      }
    }
    if (nextProps.refreshFlag !== this.props.refreshFlag) {
      this.reloadDefinition(nextProps.moduleStudy);
      this.props.definitionActions.clearDefinitionTarget();
    }
  }

  onLeafNodeClicked = selectedDefinition =>
    this.setState({ selectedDefinition }, () =>
      this.props.definitionActions.getDefinitionTargetLoad(
        this.props.activeAccountId,
        selectedDefinition.definitionId,
      ),
    );

  handleDrop = (newExpressions, selectedDefinition) => {
    if (selectedDefinition) {
      this.setState({ selectedDefinition }, () =>
        this.patchDefinition({ newExpressions }),
      );
    } else {
      this.patchDefinition({ newExpressions });
    }
  };

  patchDefinition = ({ deletes, newExpressions }) => {
    newExpressions.forEach((item) => {
      item.expression = item.expression.replaceAll('\t', '');
      });
    const patchDefinition = {
      token: this.props.loginResponse.data.token,
      ssid: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      definitionId: this.state.selectedDefinition.definitionId,
      deletes,
      newExpressions,
      // refreshDefinitions: true,
    };
    this.props.definitionActions.patchTargetFolder(patchDefinition);
  };

  editDefinition = ({ folderName, shared, thisStudy, definitionId }) => {
    const definitionObj = {
      token: this.props.loginResponse.data.token,
      ssid: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      folderName,
      shared,
      thisStudy,
      // refreshDefinitions: true,
    };
    if (definitionId) {
      this.setState({
        selectedDefinition: {
          ...this.state.selectedDefinition,
          productId: thisStudy ? this.props.moduleStudy.pn : 0,
          folderName,
          shared,
        },
      });

      definitionObj.definitionId = definitionId;
      this.props.definitionActions.patchTargetFolder(definitionObj);
    } else {
      this.props.definitionActions.createNewDefinition(definitionObj);
    }
  };

  handleDelete = () => {
    if (
      this.definitionTarget &&
      this.definitionTarget.getDecoratedComponentInstance().getSelectedTargets()
        .length > 0
    ) {
      this.patchDefinition({
        deletes: this.definitionTarget
          .getDecoratedComponentInstance()
          .getSelectedTargets()
          .map(target => target.expressionId),
      });
    } else {
      this.props.definitionActions.deleteDefinition(
        this.props.loginResponse.data.token,
        this.props.moduleStudy.ss === 'SIMMONS' ? 1: 2,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        this.state.selectedDefinition.definitionId,
      );
      this.setState({ selectedDefinition: {} });
    }
    this.deleteDefinitionModal.hide();
  };

  reloadDefinition = moduleStudy => {
    this.props.definitionActions.getDefinitionTreeLoad(
      this.props.loginResponse.data.token,
      moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      this.props.activeAccountId,
      moduleStudy.pn,
    );
  }

  render() {
    return (
      <div className="definitions-controls-buttons">
        <div className="button-group">
          <GenericButton
            name="Create"
            btnStyle="button btn-coding-box-options"
            onBtnClick={() => this.createDefinitionModal.show()}
          />
          <GenericButton
            name="Edit"
            btnStyle="button btn-coding-box-options"
            onBtnClick={() => this.editDefinitionModal.show()}
            {...(!(
              this.state.selectedDefinition.scope === 4 ||
              this.state.selectedDefinition.scope === 5
            )
              ? { btnDisabled: true }
              : {})}
          />
          <GenericButton
            name="Duplicate"
            btnStyle="button btn-coding-box-options"
            onBtnClick={() => this.duplicateDefinitionModal.show()}
            {...(!this.state.selectedDefinition.definitionId
              ? { btnDisabled: true }
              : {})}
          />
          <GenericButton
            name="Delete"
            btnStyle="button btn-coding-box-options"
            onBtnClick={() => this.deleteDefinitionModal.show()}
            {...(!(
              this.state.selectedDefinition.scope === 4 ||
              this.state.selectedDefinition.scope === 5
            )
              ? { btnDisabled: true }
              : {})}
          />
          <GenericButton
            name="Browse Shared"
            btnStyle="button btn-coding-box-options"
            onBtnClick={() => this.sharedDefinitionModal.show()}
          />
          <GenericSendToPopover
            btnName="Import"
            dropdownOptions={[
              {
                name: 'Import Custom Geography',
                disabled: this.props.moduleStudy &&
                  !this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG),
                onClickHandler: () => {
                  this.importCustomGeographiesModal.show();
                },
              },
              {
                name: 'Import Respondent List',
                disabled: false,
                onClickHandler: () => {
                  this.importRespondentsModal.show();
                },
              },
              {
                name: 'Close',
                disabled: false,
                onClickHandler: () => { },
              },
            ]}
            {...(!this.state.showBtn ? { btnDisabled: false } : {})}
          />
        </div>
        <div className="expanded row definition-wrapper">
          <div className="small-12 medium-6 large-6 columns padding-0">
            <DefinitionTreeV2
              definitionList={this.state.definitionList}
              handleClick={this.onLeafNodeClicked}
              activeAccountId={this.props.activeAccountId}
              handleTreeDrop={this.handleDrop}
              noExpressionBox={this.props.noExpressionBox}
            />
          </div>
          <div className="small-12 medium-6 large-6 end columns padding-0">
            <DefinitionTarget
              ref={node => (this.definitionTarget = node)}
              handleAnswersPreview={this.props.handleAnswersPreview}
              targetData={this.state.targetData}
              selectedDefinition={this.state.selectedDefinition}
              handleTargetDrop={this.handleDrop}
            />
          </div>
        </div>
        <Modal
          title="New Definition..."
          ref={node => (this.createDefinitionModal = node)}
          dialogStyles={smallModalStyle}
        >
          <CreateEditDefinition
            shared={false}
            thisStudy={false}
            editDefinition={this.editDefinition}
            handleHide={() => this.createDefinitionModal.hide()}
          />
        </Modal>
        <Modal
          title="Delete Definition"
          ref={node => (this.deleteDefinitionModal = node)}
          dialogStyles={smallModalStyle}
        >
          <div className="small-12 columns">
            <div className="column row">
              <p>Are you sure you want to delete this definition?</p>
              <div className="button-group text-right">
                <GenericButton
                  name="Yes"
                  btnStyle="button"
                  onBtnClick={this.handleDelete}
                />
                <GenericButton
                  name="No"
                  btnStyle="button"
                  onBtnClick={() => this.deleteDefinitionModal.hide()}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          title="Edit Definition..."
          ref={node => (this.editDefinitionModal = node)}
          dialogStyles={smallModalStyle}
        >
          <CreateEditDefinition
            shared={!!this.state.selectedDefinition.shared}
            thisStudy={!!this.state.selectedDefinition.productId}
            folderName={this.state.selectedDefinition.folderName}
            definitionId={this.state.selectedDefinition.definitionId}
            editDefinition={this.editDefinition}
            handleHide={() => this.editDefinitionModal.hide()}
          />
        </Modal>
        <Modal
          title="Add to Definition..."
          ref={node => (this.duplicateDefinitionModal = node)}
          dialogStyles={smallModalStyle}
        >
          <AddToDefinition
            folderName={`Copy of ${this.state.selectedDefinition.folderName}`}
            newExpressions={this.state.targetData.map(
              ({ title, expression }) => ({ id: 0, name: title, expression }),
            )}
            handleHide={() => this.duplicateDefinitionModal.hide()}
            srcScreen="DefinitionScreen"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
        <Modal
          title="Adopt Shared Definition"
          ref={node => (this.sharedDefinitionModal = node)}
          dialogStyles={mediumModalStyle}
        >
          <BrowseShared
            handleHide={() => this.sharedDefinitionModal.hide()}
            token={this.props.loginResponse.data.token}
            uid={this.props.loginResponse.data.uid}
            accountId={this.props.activeAccountId}
            productNo={
              this.props.moduleStudy ? this.props.moduleStudy.pn : -1
            }
            studySource={this.props.moduleStudy && this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2}
          />
        </Modal>
        <Modal
          title="Import Custom Geographies"
          ref={node => (this.importCustomGeographiesModal = node)}
          dialogStyles={smallModalStyle}
        >
          <ImportGeographyAndRespondent
            handleHide={() => this.importCustomGeographiesModal.hide()}
            srcScreen="DefinitionScreen"
            importType="Geography"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
        <Modal
          title="Import Respondents"
          ref={node => (this.importRespondentsModal = node)}
          dialogStyles={smallModalStyle}
        >
          <ImportGeographyAndRespondent
            handleHide={() => this.importRespondentsModal.hide()}
            srcScreen="DefinitionScreen"
            importType="Respondent"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
      </div>
    );
  }
}

DefinitionsV2.propTypes = {
  handleAnswersPreview: PropTypes.func,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    st: PropTypes.string,
    ss: PropTypes.string,
  }),
  definitionList: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  definitionTarget: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
    getDefinitionTargetLoad: PropTypes.func,
    createNewDefinition: PropTypes.func,
    deleteDefinition: PropTypes.func,
    patchTargetFolder: PropTypes.func,
    clearDefinitionTarget: PropTypes.func,
  }),
  noExpressionBox: PropTypes.bool,
  refreshFlag: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    definitionList: state.definition.definitionTree,
    definitionTarget: state.definition.definitionTarget,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    definitionActions: bindActionCreators(definitionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefinitionsV2);
